import { useState } from 'react';
import {
  Box, Button, TextField, Snackbar, IconButton, InputAdornment,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../common/components/LocalizationProvider';
import CloseIcon from '@mui/icons-material/Close';
import VpnLockIcon from '@mui/icons-material/VpnLock';
import LoginLayout from './LoginLayout';
import LogoImage from '../common/auth/LogoImage';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(0, 0, 0, 0.5)"
      : "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(12px)",
    padding: theme.spacing(3),
    borderRadius: "16px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
    maxWidth: "420px",
    width: "100%",
    position: "relative",
    zIndex: 1,
    margin: "auto",
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5),
      gap: theme.spacing(1.5),
      maxWidth: "95%",
    },
  },
  input: {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "8px",
    background: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.1)"
      : "rgba(0, 0, 0, 0.05)",
    "&:focus-within": {
      background: theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.08)",
    },
  },
  actionButton: {
    background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: "white",
    fontWeight: "bold",
    padding: "14px 0",
    borderRadius: "8px",
    fontSize: "1rem",
    minHeight: "44px",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
    },
    transition: "all 0.2s ease",
  },
}));

const ChangeServerPage = () => {
  const { classes } = useStyles();
  const t = useTranslation();
  const navigate = useNavigate();

  const [hostname, setHostname] = useState(window.localStorage.getItem('hostname') || '');
  const [snackbar, setSnackbar] = useState('');

  const handleChangeServer = async (event) => {
    event.preventDefault();
    try {
      if (!hostname) {
        setSnackbar(t('sharedHostnameRequired'));
        return;
      }
      window.localStorage.setItem('hostname', hostname);
      setSnackbar(t('settingsServerChanged'));
      setTimeout(() => navigate('/login'), 1000);
    } catch (error) {
      setSnackbar(error.message);
    }
  };

  return (
    <LoginLayout>
      <Box className={classes.container}>
        <LogoImage />

        {/* Hostname */}
        <TextField
          required
          placeholder={t("settingsServer")}
          name="hostname"
          value={hostname}
          autoFocus
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <VpnLockIcon />
              </InputAdornment>
            ),
            className: classes.input,
            disableUnderline: true,
          }}
          onChange={(e) => setHostname(e.target.value)}
        />

        {/* Botão Alterar */}
        <Button
          onClick={handleChangeServer}
          type="submit"
          variant="contained"
          color="primary"
          disabled={!hostname}
          className={classes.actionButton}
        >
          {t('settingsChangeServer')}
        </Button>

        {/* Botão Voltar */}
        <Button
          onClick={() => navigate('/login')}
          variant="outlined"
          color="primary"
          size="small"
          sx={{ mt: 1 }}
        >
          {t('sharedBack')}
        </Button>
      </Box>

      {/* Snackbar mensagens */}
      <Snackbar
        open={!!snackbar}
        message={snackbar}
        autoHideDuration={4000}
        onClose={() => setSnackbar('')}
        action={(
          <IconButton size="small" color="inherit" onClick={() => setSnackbar('')}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      />
    </LoginLayout>
  );
};

export default ChangeServerPage;
